// extracted by mini-css-extract-plugin
export default {"features":"FeatureBlock_features__QfUMH","featuresItem":"FeatureBlock_featuresItem__n9dQh","dropdownItem":"FeatureBlock_dropdownItem__SzHuB"};